export const ColumnsType = {
  Default: 0,
  DateFormat: 1,
  ConvertType: 2,
  MaskNameFormat: 3,
};
